import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import APIService from "../components/postServices";
import { Button } from "primereact/button";
import PublicHeader from "../components/header";

function OtpForm() {
  const navigate = useNavigate();
  const location = useLocation();
  const [ApplicationData, setApplicationData] = useState(null);
  // Use a single useEffect to handle setting ApplicationData and redirection
  useEffect(() => {
    const data = location.state?.data;

    if (data) {
      setApplicationData(data);
    } else {
      navigate("/");
    }
  }, [location.state, navigate, ApplicationData]);

  // console.log("OtpForm", ApplicationData);

  const [paymentFormData, setPaymentFormData] = useState(null);
  const [otpResendFormData, setOtpResendFormData] = useState({
    studentNo: "",
    dob: "",
    mobile: "",
    email: "",
  });

  useEffect(() => {
    if (ApplicationData) {
      setPaymentFormData({
        studentNo: ApplicationData && ApplicationData.studentNo,
        class: ApplicationData && ApplicationData.class,
        section: ApplicationData && ApplicationData.section,
        mobile: ApplicationData && ApplicationData.mobile,
        email: ApplicationData && ApplicationData.email,
        dob: ApplicationData && ApplicationData.dob,

        otpPassword: "",
      });

      setOtpResendFormData({
        studentNo: ApplicationData && ApplicationData.studentNo,
        dob: ApplicationData && ApplicationData.dob,
        mobile: ApplicationData && ApplicationData.mobile,
        email: ApplicationData && ApplicationData.email,
      });
    }
  }, [ApplicationData]);

  // +++++++++++++++++++ count down ++++++++++++++

  const [seconds, setSeconds] = useState(60);

  useEffect(() => {
    const timer = setInterval(() => {
      setSeconds((prevSeconds) => {
        if (prevSeconds === 1) {
          setResendButtonVisible(true);
          clearInterval(timer);
          // You can add additional logic here when the timer reaches 0
        }
        return prevSeconds > 0 ? prevSeconds - 1 : 0; // Ensure the countdown doesn't go below 0
      });
    }, 1000);

    // Cleanup function to clear the interval when the component unmounts
    return () => clearInterval(timer);
  }, [seconds === 60]); //

  // +++++++++++++++ Resend otp +++++++++++++++++++++++

  const [resendButtonVisible, setResendButtonVisible] = useState(false);

  // UseEffect to toggle resend button visibility after 1 minute
  // useEffect(() => {
  //   const timeoutId = setTimeout(() => {
  //     setResendButtonVisible(true);
  //   }, 60000); // 1 minute in milliseconds

  //   return () => {
  //     clearTimeout(timeoutId); // Clear the timeout when the component unmounts or when ApplicationData changes
  //   };
  // }, [ApplicationData]);

  const resendOtp = async () => {
    setSeconds(60);
    try {
      const response = await APIService.Post(
        `/User/AddNewQuickPaymentUsers`,
        otpResendFormData
      );

      if (response.responseCode === 1) {
        setResendButtonVisible(false); // Hide the button again after initiating resend
      }
    } catch (error) {
      // setLoading(false);
      // console.error("Error:", error);
    }
    // setLoading(false);
  };

  // +++++++++++++++ end Resend otp +++++++++++++++++++++++

  const [error, setError] = useState({});

  const [otpError, setotpError] = useState("");

  const PaymentFormDataChange = (event) => {
    const { name, value } = event.target;
    // Update the form state with the new value
    setPaymentFormData({
      ...paymentFormData,
      [name]: value,
    });

    console.log("PaymentFormDataChange", name);
  };

  const verifyOtp = async (e) => {
    e.preventDefault();
    let isValid = true;
    let otpPassword = paymentFormData.otpPassword;

    if (otpPassword === "") {
      setotpError("Please input OTP", "otpPassword");
      setError(true);
      isValid = false;
    }
    if (isValid) {
      try {
        const response = await APIService.Post(`/auth`, paymentFormData);
        console.log(response);
        if (response.responseCode === 1) {
          // setIsOtp(true);
          console.log("response", response.dataSet);
          navigate("/Payonline", {
            state: { data: response.dataSet },
            replace: true,
          });

          setApplicationData(null);
          setPaymentFormData({});
        }
      } catch (error) {
        console.error("Error:", error);
      }
    }
  };

  const breadcrumb = [{ label: "Online Payment", url: "/" }];

  return (
    <div className="main-page">
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
      <PublicHeader breadcrumb={breadcrumb} title={"Online Payment"} />

      <div className="content-wrapper  mt-10">
        <div className="col-md-12">
          <h3 className="text-center">
            Online Payment
            {/* <small>Make payment and submit the application form</small> */}
          </h3>

          <div className=" reg">
            <div className="box-header text-center">
              <h3 className="box-title">Information</h3>
            </div>
            <div className="box-body">
              <div className="col-md-12 p-25">
                <div className="otpSection">
                  <div className="row">
                    <p style={{ color: "green" }}>
                      Kindly verify your Email or WhatsApp for the OTP (One-Time
                      Password).
                    </p>{" "}
                  </div>
                  <div className="form-group row">
                    <label className="col-md-4 col-form-label">
                      Please Enter OTP
                      <i aria-hidden="true" className="ml-2 redColor">
                        {" "}
                        *{" "}
                      </i>{" "}
                    </label>
                    <div className="col-md-8">
                      <div className="input-group">
                        <input
                          type="text"
                          placeholder="_ _ _ _ _ _"
                          className="form-control form-control-sm"
                          id="otpPassword"
                          name="otpPassword"
                          value={paymentFormData && paymentFormData.otpPassword}
                          onChange={PaymentFormDataChange}
                          onFocus={() => setotpError("")}
                        />
                      </div>
                      {error && otpError.otpPassword && (
                        <span className="redColor">{otpError.otpPassword}</span>
                      )}
                    </div>
                  </div>
                  <div className="row">
                    {seconds >= 1 && (
                      <span className="text-red">
                        {" "}
                        You will receive an OTP in {seconds} seconds
                      </span>
                    )}
                    {seconds == 0 && resendButtonVisible && (
                      <span className="ml-2">
                        OTP not received?{" "}
                        <button onClick={resendOtp} className="resend-link">
                          Click here to resend OTP
                        </button>
                      </span>
                    )}
                  </div>
                  <div
                    className="row button-container pull-right"
                    style={{ justifyContent: "center" }}
                  >
                    <Button
                      label="Verify OTP"
                      onClick={verifyOtp}
                      severity="danger"
                      size="large"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OtpForm;
